// SettingsPage.tsx - Main settings page
import { Container, Tabs } from '@mantine/core';
import { IconUser, IconShield, IconSettings } from '@tabler/icons-react';
import { ProfileSettings } from '@/components/profile/ProfileSettings';
import { SecuritySettings } from '@/components/profile/SecuritySettings';

export function SettingsPage() {
  return (
    <Container size="xl" py="xl">
      <Tabs defaultValue="profile">
        <Tabs.List>
          <Tabs.Tab value="profile" leftSection={<IconUser size={16} />}>
            Profile
          </Tabs.Tab>
          <Tabs.Tab value="security" leftSection={<IconShield size={16} />}>
            Security
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="profile" pt="xl">
          <ProfileSettings />
        </Tabs.Panel>

        <Tabs.Panel value="security" pt="xl">
          <SecuritySettings />
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
}
